import React from 'react';
import { InformationLayout } from './InformationLayout';

export const Information = () => <InformationLayout />;
